export const dropZoneStyle = {
  width: "auto",
};
